module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_sekundærlogo_neg(hvit).8bb2ad02.pdf";